var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"text-center p-3"},[(_vm.lon && _vm.lat)?_c('a',{attrs:{"href":`https://maps.google.com/?q=${_vm.lat},${_vm.lon}`,"target":"_blank"}},[_vm._v(" Мое место расположение")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }